<template>
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve" width="512" height="512">
<g>
	<g>
		<path style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" d="&#10;&#9;&#9;&#9;M378.162,254.965h-78.895c-10.968,0-17.669-12.049-11.884-21.367l78.891-127.054c5.472-8.812,18.295-8.812,23.767,0&#10;&#9;&#9;&#9;l78.891,127.054c5.786,9.318-0.915,21.367-11.884,21.367h-43.873"/>
		
			<line style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" x1="378.488" y1="193.26" x2="378.488" y2="147.34"/>
		
			<line style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" x1="378.488" y1="223.441" x2="378.488" y2="223.441"/>
	</g>
	
		<circle style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" cx="378.157" cy="426.52" r="77.98"/>
	<path style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" d="&#10;&#9;&#9;M378.157,477.5c-28.11,0-50.98-22.87-50.98-50.98s22.87-50.979,50.98-50.979c28.111,0,50.98,22.869,50.98,50.979&#10;&#9;&#9;S406.268,477.5,378.157,477.5z"/>
	
		<line style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" x1="383.933" y1="421.074" x2="373.042" y2="431.965"/>
	<g>
		<path style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" d="&#10;&#9;&#9;&#9;M106.849,337.386c0,0-6.698-6.178-17.023-3.068c-9.48,2.856-11.835,15.827-5.392,20.88c3.699,2.901,9.265,5.287,16.766,7.938&#10;&#9;&#9;&#9;c16.789,5.935,10.583,29.612-6.495,29.725c-6.665,0.044-9.78-0.379-15.635-4.209"/>
		
			<line style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" x1="94.704" y1="401.503" x2="94.704" y2="392.861"/>
		
			<line style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" x1="94.704" y1="333.463" x2="94.704" y2="325.453"/>
	</g>
	<path style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" d="&#10;&#9;&#9;M40.942,378.424V20.86c0-7.38,5.99-13.36,13.37-13.36h310.48c7.38,0,13.37,5.98,13.37,13.36v79.07"/>
	<path style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" d="&#10;&#9;&#9;M309.102,462.76H54.312c-7.38,0-13.37-5.99-13.37-13.37v-35.968"/>
	
		<line style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" x1="378.162" y1="348.54" x2="378.162" y2="254.97"/>
	<g>
		
			<line style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" x1="300.177" y1="435.55" x2="68.152" y2="435.55"/>
		
			<polyline style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" points="&#10;&#9;&#9;&#9;349.392,354.02 349.392,326.23 151.992,326.23 151.992,400.73 304.552,400.73 &#9;&#9;"/>
		
			<line style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" x1="350.062" y1="289.789" x2="68.152" y2="289.789"/>
	</g>
	<g>
		
			<line style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" x1="320.373" y1="180.468" x2="151.996" y2="180.468"/>
		
			<line style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" x1="297.757" y1="217.717" x2="151.996" y2="217.717"/>
		
			<line style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" x1="348.501" y1="254.965" x2="151.996" y2="254.965"/>
		
			<line style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" x1="343" y1="144.027" x2="67.263" y2="144.027"/>
	</g>
	<g>
		<g>
			<path style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" d="&#10;&#9;&#9;&#9;&#9;M200.578,115.423V40.027l50.975,73.815c0.945,1.365,1.957,0.696,1.957-0.964l-0.706-72.992"/>
		</g>
		<g>
			
				<line style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" x1="161.546" y1="39.886" x2="161.546" y2="115.423"/>
		</g>
		<g>
			
				<polyline style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" points="&#10;&#9;&#9;&#9;&#9;125.472,39.886 95.08,39.886 95.08,114.87 &#9;&#9;&#9;"/>
			
				<line style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" x1="95.08" y1="76.668" x2="123.058" y2="76.668"/>
		</g>
		<g>
			
				<polyline style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" points="&#10;&#9;&#9;&#9;&#9;324.023,39.886 292.485,39.886 292.485,114.734 324.023,114.734 &#9;&#9;&#9;"/>
			
				<line style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" x1="321.697" y1="77.31" x2="292.485" y2="77.31"/>
		</g>
	</g>
	
		<line style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" x1="95.08" y1="180.468" x2="95.08" y2="180.468"/>
	
		<line style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" x1="95.08" y1="217.717" x2="95.08" y2="217.717"/>
	
		<line style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" x1="95.08" y1="254.965" x2="95.08" y2="254.965"/>
</g>















</svg>
</template>
